"use client";
import { motion } from "framer-motion";

const Clients = () => {
  // Logos de clientes con imágenes reales
  const clients = [
    { name: "Tenonde LTDA", logo: "/logos/tenonde.png" },
    { name: "DLT Propiedades", logo: "/logos/dltLogo.png" },
    { name: "Hermann", logo: "/logos/hermann-sinFondo.png" },
  ];


  return (
    <section id="clientes" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Clientes que <span className="text-[#77c593]">Confían</span>
          </h2>
          <div className="w-24 h-1 bg-[#77c593] mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Trabajamos junto a empresas que confían en nuestras soluciones para
            su crecimiento
          </p>
        </motion.div>

        {/* Carrusel de clientes con logos y efecto grayscale */}
        <div className="mb-16 overflow-hidden">
          <motion.div
            animate={{ x: [0, -100 * clients.length] }}
            transition={{
              duration: 30,
              repeat: Number.POSITIVE_INFINITY,
              ease: "linear",
            }}
            className="flex space-x-20 mb-8"
            style={{ width: `${clients.length * 200}px` }}
          >
            {[...clients, ...clients].map((client, index) => (
              <motion.div
                key={index}
                whileHover={{ scale: 1.05 }}
                className="flex-shrink-0 w-32 h-16 rounded-lg flex items-center justify-center hover:border-[#77c593]/30  transition-all duration-300 group"
              >
                <img
                  src={client.logo || "/placeholder.svg"}
                  alt={client.name}
                  className="max-w-24 max-h-12 object-cover filter grayscale group-hover:grayscale-0 transition-all duration-300"
                  onError={(e) => {
                    // Fallback si la imagen no carga
                    e.target.style.display = "none";
                    e.target.nextSibling.style.display = "block";
                  }}
                />
                <span
                  className="text-gray-400 font-semibold text-sm tracking-wide hidden"
                  style={{ display: "none" }}
                >
                  {client.name}
                </span>
              </motion.div>
            ))}
          </motion.div>
        </div>


      </div>
    </section>
  );
};

export default Clients;